import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalService } from 'projects/app-shared/src/public-api';
import { Usuario } from 'projects/ecommerce-generico/src/public-api';
import { GenericoSlideAnim } from '../etc/generico-animation';
import { MarianomGeneral } from '../marianom-general.service';

@Component({
  selector: 'mmax-usuario-budget',
  templateUrl: './usuario-budget-mmax.component.html',
  styleUrls: ['./usuario-budget-mmax.component.scss'],
  animations: [
    GenericoSlideAnim
  ]
})
export class UsuarioBudgetMmaxComponent implements OnInit {
  @Input('mode') modo: string;
  @Input() loader: string;
  @Input() login: string;

  constructor(private serv: MarianomGeneral, private modal: ModalService, private route: ActivatedRoute) {
    this.modo = this.modo || 'normal';
    this.usericon = {
      nombre: 'Método de Pago',
      url: 'metodosdpago',
      icourl: '../../assets/icons/misdatos.svg'
    }
    this.mobilhome = {
      nombre: 'home',
      url: '',
      urlmobile: '/app-mobile/home',
      icourl: '../../assets/icons/home.svg'
    }
    this.menus = [
      {
        nombre: 'Sucursales',
        url: '/sucursales',
        urlmobile: '/app-mobile/sucursal-change',
        icourl: '../../assets/icons/store.svg'
      },
      {
        nombre: 'Mis Datos',
        url: '/misdatos',
        urlmobile: '/app-mobile/app/account',
        icourl: '../../assets/icons/credit-card-outline-white.svg'
      },
      {
        nombre: 'Método de Pago',
        url: '/metodosdpago',

        icourl: '../../assets/icons/misdatos.svg'

      },
      {
        nombre: 'Carrito de Compras',
        url: '/resumendecompra',
        urlmobile: '/app-mobile/cart',
        icourl: '../../assets/icons/cart-arrow-down-white.svg'
      },
      {
        nombre: "Ayuda",
        url: '/ayudas',
        urlmobile: '/app-mobile/app/help',
        icourl: '../../assets/icons/help-circle-outline-white.svg'
      },
      {
        nombre: 'Salir',
        url: 'app',
        urlmobile: 'app-mobile/app',
        icourl: '../../assets/icons/logout-variant-white.svg',
        function: 'salir'
      }
    ];
    //this.desplegado=false;
    this.loader = this.loader || 'none';
    this.login = this.login || 'none';
    this.serv.getUserProvider().subscribe(data => {
      //console.log(data);
      this.login = 'flex';
      this.loader = 'none';
      this.usuario = data;

    });

  }
  ngOnInit(): void {
    this.loader = 'block';

    if (this.loader === 'block') {
      this.login = 'none';
    }
  }
  salir() {
    this.serv.salirylimpiar();

  }
  gotoURL(url: string) {
    if (url === "/resumendecompra") {
      if (this.total === 0) {
        this.modal.open('modal-agregar-producto');
      } else {
        this.serv.gotoURL(url, this.route);
      }
    }
    else {
      this.serv.gotoURL(url, this.route);
    }

  }
  closebudget() {
    this.serv.desplegaryCerrarusu(!this.desplegado);
  }
  get total() {
    return this.serv.getCantidadTotal();
  }
  ejecutar(funcion) {
    if (funcion != undefined) {
      this[funcion]();
    }

  }
  volverAtras() {
    this.serv.navigator.goLandPage(this.route);
  }
  volverAtrasMobile() {
    this.serv.navigator.goLandPage(this.route);
  }
  startLoginMobile() {
    this.serv.gotoURL('login', this.route);
  }
  loginStart() {
    this.modal.open('login-modal-1');
  }
  cerrarModale(nombre) {
    this.modal.close(nombre);
  }
  get nombreSucursal() {
    if (this.usuario.sucursal === 0) {
      return (" Sucursal " + this.serv.getSucursalDefecto());
    }
    else {
      return this.usuario.sucursalNombre || ' Sin Definir'
    }
  }
  get desplegado() {
    return this.serv.desplegadousa;
  }
  menus: UsuariosBudgetMenu[];
  mobilhome: UsuariosBudgetMenu;
  usericon: UsuariosBudgetMenu;
  usuario: Usuario;
}

export interface UsuariosBudgetMenu {
  nombre: string,
  url: string,
  urlmobile?: string,
  urltablet?: string,
  icourl?: string,
  function?: string,
}
